import { Badge } from "@component/badge";
import { Button } from "@component/button";
import { EmptyState } from "@component/empty-state";
import { Input } from "@component/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@component/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@component/table";
import { PayrollItem } from "@type/payment";
import { convertCurrency } from "@util/currency";
import { parseFormat } from "@util/date";
import { getPayrollStatusColor } from "@util/string";
import { CreditCardIcon, Eye, SearchIcon } from "lucide-react";
import { useState } from "react";

interface Props {
    onShowModalPaymentSetting: () => void
}

export default function CandidateListPayroll(props: Props) {
    const [selectedStatus, setSelectStatus] = useState<string>("");
    const [payrolls] = useState<PayrollItem[]>([])

    const handleSearchChange = () => { }

    return (
        <>
            <div className="flex flex-col sm:flex-row gap-3 mb-4 w-full">
                <div className="relative flex-grow">
                    <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />

                    <Input
                        placeholder="Search jobs by title or company..."
                        className="pl-9 w-full"
                        onChange={handleSearchChange}
                    />
                </div>
                <Select value={selectedStatus} onValueChange={(val) => setSelectStatus(val)}>
                    <SelectTrigger className="w-full sm:w-[180px]">
                        <SelectValue placeholder="All Statuses" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">All Statuses</SelectItem>
                        <SelectItem value="pending">Pending</SelectItem>
                        <SelectItem value="processing">In Progress</SelectItem>
                        <SelectItem value="paid">Paid</SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <div className="w-full overflow-auto">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className="w-[250px]">Job</TableHead>
                                <TableHead>Start Date</TableHead>
                                <TableHead className="text-center">Total Earned</TableHead>
                                <TableHead>Payment Status</TableHead>
                                <TableHead className="w-[120px] text-center">Actions</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {payrolls.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <EmptyState
                                            icon={<CreditCardIcon className="h-6 w-6 text-blue-600" />}
                                            title="No payroll information yet."
                                            description="Set up your payment details to receive payments for your work. You can
                                                add your bank account or other payment methods."
                                            action={
                                                <Button
                                                    variant="default"
                                                    onClick={props.onShowModalPaymentSetting}
                                                >
                                                    Set up payroll
                                                </Button>
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            )}
                            {payrolls.map((payroll, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <div>
                                            <p className="font-medium">{payroll.job_title}</p>
                                            <p className="text-xs text-gray-500">{payroll.company_name}</p>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        {parseFormat(payroll.start_date, "D MMM YYYY")}
                                    </TableCell>
                                    <TableCell className="font-medium text-blue-600 text-center">
                                        {convertCurrency(payroll.total_earned, payroll.currency)}
                                    </TableCell>
                                    <TableCell>
                                        <Badge
                                            variant="outline"
                                            className={`${getPayrollStatusColor(payroll.status)} capitalize`}
                                        >
                                            {payroll.status}
                                        </Badge>
                                    </TableCell>
                                    <TableCell className="text-center">
                                        <Button variant="outline" size="sm" className="h-8 mx-auto">
                                            <Eye className="h-4 w-4 mr-1" />
                                            View Details
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </>
    )
}